import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from './applyForm.vue';
import handleDialog from './components/handleDialog.vue';
import ticketForm from './ticketForm.vue';
import ticketHandleDialog from './components/ticketHandleDialog.vue';
import ticketFollowUpDialog from './components/ticketFollowUpDialog.vue';
import ticketAssignDialog from './components/ticketAssignDialog.vue';
import FollowUpDialog from './components/FollowUpDialog.vue';
import AddCardDialog from './components/AddCardDialog.vue';
import BiddingStatusDialog from './components/biddingStatusDialog.vue';
import PrintingStatusDialog from './components/printingStatusDialog.vue';
import BiddingResultDialog from './components/biddingResultDialog.vue';
import BiddingDeliveryDialog from './components/biddingDeliveryDialog.vue';
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import CreatePrintingRecord from '@/views/salesCardManagement/createPrintingRecord.vue';
import cardCommonConfig from '@/views/order/cardCommonConfig.vue';
import { getMyToDoDefaultStatus } from './defaultForms';
import { decodeQueryData, mergeQueryData } from './deepLink';
import { addVirtualOrder, getMyToDoProjectList, getMyToDoMallList, getMyToDoBiddingList, getMyToDoCardAndCouponDesignList, getMyToDoPrintingExcel, getMyToDoQuotationList, getProjectDeliveryHandleUser, searchUserList, getProjectTicketSelect, getProjectTicketMyToDoList } from '../api';
export default {
  components: {
    applyForm: applyForm,
    handleDialog: handleDialog,
    ticketForm: ticketForm,
    ticketHandleDialog: ticketHandleDialog,
    ticketFollowUpDialog: ticketFollowUpDialog,
    ticketAssignDialog: ticketAssignDialog,
    FollowUpDialog: FollowUpDialog,
    AddCardDialog: AddCardDialog,
    BiddingStatusDialog: BiddingStatusDialog,
    PrintingStatusDialog: PrintingStatusDialog,
    BiddingResultDialog: BiddingResultDialog,
    BiddingDeliveryDialog: BiddingDeliveryDialog,
    CreatePrintingRecord: CreatePrintingRecord,
    cardCommonConfig: cardCommonConfig
  },
  props: {
    toDoProjectCount: {
      type: Number,
      default: 0
    },
    toDoMallCount: {
      type: Number,
      default: 0
    },
    toDoBiddingCount: {
      type: Number,
      default: 0
    },
    toDoPrintingCount: {
      type: Number,
      default: 0
    },
    toDoTicketCount: {
      type: Number,
      default: 0
    },
    toDoQuotationCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      tabActiveName: '1',
      cardRuleDrawerVisible: false,
      cardRuleTrendParams: {},
      cardRuleLoadingId: null,
      cardRuleKind: '',
      companyList: [],
      decorationPersonList: [],
      followUpVisible: false,
      followUpProjectId: null,
      followUpTaskId: null,
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false,
      searchForm: {
        number: '',
        item_number: '',
        user_id: null,
        status: [100, 200],
        type_of_demand: [],
        need_printing: null,
        expedited_not: null,
        urgent_printing: null,
        card_make: [],
        card_make_print: [],
        design_complexity: [],
        estimated_amount_start: '',
        estimated_amount_end: '',
        customer_id: null,
        project_name: '',
        project_type: [],
        type: [],
        person_charge_id: [],
        task_person_charge_id: null,
        bid_files: null,
        created_start: '',
        created_end: '',
        start_updated_at: '',
        end_updated_at: '',
        pageSize: 20,
        page: 1
      },
      createdAtTime: [],
      updatedAtTime: [],
      projectCreatedAtTime: [],
      mallCreatedAtTime: [],
      biddingCreatedAtTime: [],
      quotationCreatedAtTime: [],
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null,
      selectedProjectType: null,
      selectedProjectStatus: null,
      drawerTitle: '装修&项目交付申请',
      printingRecordDrawer: {
        visible: false,
        params: {}
      },
      // second_category_id 为 cascader 多选格式（数组的数组：[一级id, 二级id]），查询时取叶子 id
      ticketSearchForm: {
        work_order_no: '',
        title: '',
        second_category_id: [],
        item: '',
        status: [20],
        start_created_at: '',
        end_created_at: '',
        page: 1,
        pageSize: 20
      },
      ticketCreatedAtTime: [],
      ticketListData: [],
      ticketListPages: {
        currentPage: 1,
        totalCount: 0
      },
      ticketCategoryTree: [],
      ticketDrawerVisible: false,
      ticketFormId: null,
      ticketFormType: 'view',
      ticketFormCustomerName: '',
      ticketHandleVisible: false,
      ticketFollowUpVisible: false,
      ticketAssignVisible: false,
      quotationSearchForm: {
        number: '',
        item_number: '',
        status: [100],
        user_id: '',
        customer_id: null,
        project_name: '',
        project_type: [],
        created_start: '',
        created_end: '',
        pageSize: 20,
        page: 1
      },
      quotationListData: [],
      quotationListPages: {
        currentPage: 1,
        totalCount: 0
      }
    };
  },
  created: function created() {
    var _this = this;
    var tabList = [{
      name: '1',
      permission: '/user/project-delivery/my-to-do-project'
    }, {
      name: '2',
      permission: '/user/project-delivery/my-to-do-mall'
    }, {
      name: '3',
      permission: '/user/project-delivery/my-to-do-bidding'
    }, {
      name: '4',
      permission: '/user/project-delivery/my-to-do-printing'
    }, {
      name: '5',
      permission: '/user/project-ticket/my-to-do'
    }, {
      name: '6',
      permission: '/user/project-delivery/my-to-do-quotation'
    }];
    var firstVisibleTab = tabList.find(function (item) {
      return _this.$hasBtnRoles(item.permission);
    });
    if (!firstVisibleTab) return;
    this.tabActiveName = firstVisibleTab.name;
    // 深链兼容处理（备注：兼容期保留，后续随旧入口下线移除）：
    var isListAction = this.$route.query.action === 'list';
    if (isListAction) {
      var childTab = this.$route.query.childTab || '4';
      if (childTab === '5') {
        // 深链（咨询工单列表）：childTab=5 需咨询工单权限
        if (this.$hasBtnRoles('/user/project-ticket/my-to-do')) {
          this.tabActiveName = '5';
        }
      } else if (this.$hasBtnRoles('/user/project-delivery/my-to-do-printing')) {
        this.tabActiveName = childTab;
      }
      this.searchForm.status = this.getDefaultStatus(this.tabActiveName);
      var queryData = decodeQueryData(this.$route.query.queryData);
      if (queryData) {
        mergeQueryData(this.searchForm, queryData);
      } else if (this.$route.query.item_id) {
        // 旧深链（item_id 参数，观察期后随旧入口下线移除）：回填任务ID、去掉任务状态后查询
        this.searchForm.item_number = String(this.$route.query.item_id);
        this.searchForm.status = [];
      }
    } else {
      this.searchForm.status = this.getDefaultStatus(this.tabActiveName);
    }
    this.getCompanyList();
    this.getDecorationPersonList();
    // 初始预载人员下拉默认选项（空关键词返回默认列表）
    this.searchSubmitter('');
    this.searchQuotationSubmitter('');
    if (this.tabActiveName === '6') {
      this.getQuotationList();
      return;
    }
    this.getlist();
    // 深链（咨询工单-查看详情）：action=detail 且带 ticket_id 时切到咨询工单 tab 并打开详情抽屉
    var ticketDeepLinkId = null;
    if (this.$route.query.action === 'detail' && this.$route.query.ticket_id) {
      ticketDeepLinkId = this.$route.query.ticket_id;
      if (this.$hasBtnRoles('/user/project-ticket/my-to-do')) {
        this.tabActiveName = '5';
      }
    }
    if (this.tabActiveName === '5') {
      this.initTicketTab();
    }
    if (ticketDeepLinkId) {
      var query = _objectSpread({}, this.$route.query);
      delete query.ticket_id;
      this.$router.replace({
        query: query
      });
      if (this.tabActiveName === '5') {
        this.ticketFormId = String(ticketDeepLinkId);
        this.ticketFormType = 'view';
        this.ticketFormCustomerName = '';
        this.ticketDrawerVisible = true;
      }
    }
    if (this.$route.query.id) {
      var id = this.$route.query.id;
      var _query = _objectSpread({}, this.$route.query);
      delete _query.id;
      this.$router.replace({
        query: _query
      });
      // 旧深链（无 action 或 action=detail）：打开详情抽屉（兼容保留，观察期后随旧入口下线移除）
      if (!isListAction) {
        this.selectedId = id;
        this.selectedProjectType = this.$route.query.project_type;
        this.selectedProjectStatus = this.$route.query.status;
        this.applyFormType = 'view';
        this.applyFormVisible = true;
      }
    }
  },
  methods: {
    // 卡规则保存/交付信息保存后仅关闭抽屉，刷新统一走关闭回调
    handleCardRuleSuccess: function handleCardRuleSuccess() {
      this.cardRuleDrawerVisible = false;
    },
    // 关闭抽屉时刷新报价单配置列表与角标（交付信息保存会联动任务状态）
    handleCardRuleDrawerClose: function handleCardRuleDrawerClose() {
      this.getQuotationList();
      this.$emit('countChange', {
        tabKey: 'quotation',
        searchForm: null
      });
    },
    // 首次点击由后端创建虚拟订单，用返回的订单号打开卡规则
    openCardRuleDrawer: function openCardRuleDrawer(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, orderId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this2.cardRuleLoadingId = row.id;
              _context.p = 1;
              _context.n = 2;
              return addVirtualOrder({
                sale_project_delivery_id: row.project_delivery_id
              });
            case 2:
              res = _context.v;
              orderId = res.data && res.data.order_id;
              if (orderId) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              // 功能菜单描述：1 通用卡规则走标准卡规则（功能菜单/基本规则只读），其余按个性化处理
              _this2.cardRuleKind = String(row.description) === '1' ? 'standard' : '';
              _this2.cardRuleTrendParams = {
                order_id: orderId,
                cardBinGroupId: '',
                bin_id: res.data && res.data.bin_id || '',
                flag: 'order',
                // 订单入口
                menuType: 'orderDetails',
                entryType: 'orderManage',
                premium_price: ''
              };
              _this2.cardRuleDrawerVisible = true;
            case 4:
              _context.p = 4;
              _this2.cardRuleLoadingId = null;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 4, 5]]);
      }))();
    },
    // 印刷单列：制卡/印刷ID 带点击类型，点击后与添加制卡/添加印刷单入口效果一致
    getPrintingSheetValues: function getPrintingSheetValues(row) {
      var values = [];
      if (Number(row.expedited_not) === 2) values.push({
        text: '加急设计'
      });
      if (Number(row.need_printing) === 1) {
        values.push({
          text: Number(row.urgent_printing) === 2 ? '需要印刷-加急' : '需要印刷'
        });
      } else if (Number(row.need_printing) === 2) {
        values.push({
          text: '不需要印刷'
        });
      }
      if (Number(row.printing_quantity) > 0) {
        values.push({
          text: "\u6570\u91CF\uFF1A".concat(row.printing_quantity)
        });
      }
      if (row.card_make_batch) {
        values.push({
          label: '制卡：',
          value: row.card_make_batch,
          type: 'card'
        });
      }
      if (row.card_make_print_id && String(row.card_make_print_id) !== '0') {
        values.push({
          label: '印刷ID：',
          value: row.card_make_print_id,
          type: 'print'
        });
      }
      return values;
    },
    handlePrintingSheetClick: function handlePrintingSheetClick(row, type) {
      if (type === 'card') {
        this.handleAddCard(row);
        return;
      }
      this.openPrintingRecordDrawer(row);
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === this.tabActiveName) return;
      this.tabActiveName = tab.name;
      if (tab.name === '5') {
        this.initTicketTab();
        this.$emit('countChange', {
          tabKey: 'ticket',
          searchForm: null
        });
        return;
      }
      if (tab.name === '6') {
        this.quotationSearchForm = {
          number: '',
          item_number: '',
          status: [100],
          user_id: '',
          customer_id: null,
          project_name: '',
          project_type: [],
          created_start: '',
          created_end: '',
          pageSize: 20,
          page: 1
        };
        this.quotationCreatedAtTime = [];
        this.getQuotationList();
        this.$emit('countChange', {
          tabKey: 'quotation',
          searchForm: null
        });
        return;
      }
      this.searchForm.number = '';
      this.searchForm.item_number = '';
      this.searchForm.user_id = null;
      this.searchForm.status = this.getDefaultStatus(tab.name);
      this.searchForm.type_of_demand = [];
      this.searchForm.need_printing = null;
      this.searchForm.expedited_not = null;
      this.searchForm.urgent_printing = null;
      this.searchForm.estimated_amount_start = '';
      this.searchForm.estimated_amount_end = '';
      this.searchForm.card_make = [];
      this.searchForm.card_make_print = [];
      this.searchForm.design_complexity = [];
      this.searchForm.customer_id = null;
      this.searchForm.project_name = '';
      this.searchForm.project_type = [];
      this.searchForm.type = [];
      this.searchForm.person_charge_id = [];
      this.searchForm.task_person_charge_id = null;
      this.searchForm.bid_files = null;
      this.searchForm.created_start = '';
      this.searchForm.created_end = '';
      this.searchForm.start_updated_at = '';
      this.searchForm.end_updated_at = '';
      this.searchForm.pageSize = 20;
      this.searchForm.page = 1;
      this.createdAtTime = [];
      this.updatedAtTime = [];
      this.projectCreatedAtTime = [];
      this.mallCreatedAtTime = [];
      this.biddingCreatedAtTime = [];
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(tab.name),
        searchForm: null
      });
    },
    getDefaultStatus: function getDefaultStatus(tabName) {
      return getMyToDoDefaultStatus(tabName);
    },
    getTabKey: function getTabKey(tabName) {
      var map = {
        1: 'project',
        2: 'mall',
        3: 'bidding',
        4: 'card',
        5: 'ticket',
        6: 'quotation'
      };
      return map[tabName] || 'project';
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              kw = (keyword || '').trim();
              _this3.personLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context2.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this3.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this3.personOptionCache[String(id)];
              }).filter(Boolean);
              _this3.$set(_this3.personOptions, field, picked.concat(list));
            case 3:
              _context2.p = 3;
              _this3.personLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1,, 3, 4]]);
      }))();
    },
    // 提交人（列表筛选）
    searchSubmitter: function searchSubmitter(keyword) {
      var _this4 = this;
      return this.searchPerson(keyword, 'submitter', function () {
        return _this4.searchForm.user_id;
      });
    },
    // 提交人（报价单配置）
    searchQuotationSubmitter: function searchQuotationSubmitter(keyword) {
      var _this5 = this;
      return this.searchPerson(keyword, 'quotationSubmitter', function () {
        return _this5.quotationSearchForm.user_id;
      });
    },
    getCompanyList: function getCompanyList(val) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 1:
              res = _context3.v;
              _this6.companyList = res.data.list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 项目负责人下拉选项，与项目列表筛选同源
    getDecorationPersonList: function getDecorationPersonList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return getProjectDeliveryHandleUser({
                type: 3
              });
            case 1:
              res = _context4.v;
              _this7.decorationPersonList = res.data.list || [];
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getlist: function getlist() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var apiFn, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!['5', '6'].includes(_this8.tabActiveName)) {
                _context5.n = 1;
                break;
              }
              _this8.listData = [];
              _this8.listPages = {
                currentPage: 1,
                totalCount: 0
              };
              return _context5.a(2);
            case 1:
              apiFn = getMyToDoProjectList;
              if (_this8.tabActiveName === '1') {
                apiFn = getMyToDoProjectList;
              } else if (_this8.tabActiveName === '2') {
                apiFn = getMyToDoMallList;
              } else if (_this8.tabActiveName === '3') {
                apiFn = getMyToDoBiddingList;
              } else if (_this8.tabActiveName === '4') {
                apiFn = getMyToDoCardAndCouponDesignList;
              }
              _context5.n = 2;
              return apiFn(_this8.searchForm);
            case 2:
              res = _context5.v;
              _this8.listData = res.data.data;
              _this8.listPages = res.pages;
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 跟进提交成功：报价单配置列表数据独立，需按 tab 选择刷新目标
    handleFollowUpSuccess: function handleFollowUpSuccess() {
      if (this.tabActiveName === '6') {
        this.getQuotationList();
      } else {
        this.getlist();
      }
    },
    // 报价单配置列表
    getQuotationList: function getQuotationList() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return getMyToDoQuotationList(_this9.quotationSearchForm);
            case 1:
              res = _context6.v;
              _this9.quotationListData = res.data && res.data.data || [];
              _this9.quotationListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    quotationResetList: function quotationResetList() {
      this.quotationSearchForm.page = 1;
      this.getQuotationList();
      this.$emit('countChange', {
        tabKey: 'quotation',
        searchForm: _objectSpread({}, this.quotationSearchForm)
      });
    },
    handleQuotationPageChange: function handleQuotationPageChange(page) {
      this.quotationSearchForm.page = page;
      this.getQuotationList();
      var dom = document.getElementById('quotationSearchDom');
      dom && dom.scrollIntoView();
    },
    quotationSizeChange: function quotationSizeChange(size) {
      this.quotationSearchForm.pageSize = size;
      this.quotationSearchForm.page = 1;
      this.getQuotationList();
    },
    initTicketTab: function initTicketTab() {
      if (!this.ticketCategoryTree.length) {
        this.getTicketCategoryTree();
      }
      this.getTicketList();
    },
    getTicketCategoryTree: function getTicketCategoryTree() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return getProjectTicketSelect();
            case 1:
              res = _context7.v;
              _this0.ticketCategoryTree = res.data && res.data.tree || [];
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getTicketList: function getTicketList() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var secondCategoryIds, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              // cascader 多选值为路径数组（[一级id, 二级id]），接口需要叶子（二级）id 数组
              secondCategoryIds = _this1.ticketSearchForm.second_category_id.map(function (path) {
                return path.length ? path[path.length - 1] : null;
              });
              _context8.n = 1;
              return getProjectTicketMyToDoList({
                work_order_no: _this1.ticketSearchForm.work_order_no,
                title: _this1.ticketSearchForm.title,
                second_category_id: secondCategoryIds,
                item: _this1.ticketSearchForm.item,
                status: _this1.ticketSearchForm.status,
                start_created_at: _this1.ticketSearchForm.start_created_at,
                end_created_at: _this1.ticketSearchForm.end_created_at,
                page: _this1.ticketSearchForm.page,
                pageSize: _this1.ticketSearchForm.pageSize
              });
            case 1:
              res = _context8.v;
              _this1.ticketListData = res.data.data || [];
              _this1.ticketListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    ticketResetList: function ticketResetList() {
      this.ticketSearchForm.page = 1;
      this.getTicketList();
      this.emitTicketCountChange();
    },
    // 咨询工单搜索后联动角标：cascader 取叶子节点 id，与列表请求口径一致
    emitTicketCountChange: function emitTicketCountChange() {
      var secondCategoryIds = this.ticketSearchForm.second_category_id.map(function (path) {
        return path.length ? path[path.length - 1] : null;
      });
      this.$emit('countChange', {
        tabKey: 'ticket',
        searchForm: {
          work_order_no: this.ticketSearchForm.work_order_no,
          title: this.ticketSearchForm.title,
          second_category_id: secondCategoryIds,
          item: this.ticketSearchForm.item,
          status: this.ticketSearchForm.status,
          start_created_at: this.ticketSearchForm.start_created_at,
          end_created_at: this.ticketSearchForm.end_created_at,
          page: 1,
          pageSize: this.ticketSearchForm.pageSize
        }
      });
    },
    handleTicketPageChange: function handleTicketPageChange(page) {
      this.ticketSearchForm.page = page;
      this.getTicketList();
      var dom = document.getElementById('ticketSearchDom');
      dom.scrollIntoView();
    },
    ticketSizeChange: function ticketSizeChange(size) {
      this.ticketSearchForm.pageSize = size;
      this.ticketSearchForm.page = 1;
      this.getTicketList();
    },
    changeTicketCreatedAtTime: function changeTicketCreatedAtTime(val) {
      this.ticketSearchForm.start_created_at = val ? val[0] : '';
      this.ticketSearchForm.end_created_at = val ? val[1] : '';
    },
    viewTicketDetail: function viewTicketDetail(row) {
      this.ticketFormId = row.id;
      this.ticketFormType = 'view';
      this.ticketFormCustomerName = row.customer_info && row.customer_info.company_name || '';
      this.ticketDrawerVisible = true;
    },
    openTicketHandle: function openTicketHandle(row) {
      this.$refs.ticketHandleDialog.open(row.id);
    },
    openTicketFollowUp: function openTicketFollowUp(row) {
      this.$refs.ticketFollowUpDialog.open(row.id);
    },
    openTicketAssign: function openTicketAssign(row) {
      this.$refs.ticketAssignDialog.open(row.id);
    },
    // 工单操作（处理/跟进/修改负责人）成功：刷新列表并联动顶部/子tab角标计数
    handleTicketActionSuccess: function handleTicketActionSuccess() {
      this.getTicketList();
      this.$emit('countChange', {
        tabKey: 'ticket',
        searchForm: null
      });
    },
    handleTicketFormSuccess: function handleTicketFormSuccess() {
      this.ticketDrawerVisible = false;
      this.getTicketList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.getlist();
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      // 订单预计金额：起始值不能大于结束值
      if (this.tabActiveName == '4' && this.searchForm.estimated_amount_start && this.searchForm.estimated_amount_end && Number(this.searchForm.estimated_amount_start) > Number(this.searchForm.estimated_amount_end)) {
        this.$message.warning('订单预计金额最小值不能大于最大值');
        return;
      }
      this.searchForm.page = 1;
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    handleClose: function handleClose() {
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    viewDetail: function viewDetail(row) {
      this.selectedId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.selectedProjectType = row.project_type;
      this.selectedProjectStatus = this.getProjectStatus(row);
      this.applyFormType = 'view';
      if (this.tabActiveName == '1') {
        this.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
      } else {
        this.drawerTitle = '装修&项目交付申请（任务ID：' + row.number + '）';
      }
      this.applyFormVisible = true;
    },
    handleProcess: function handleProcess(row) {
      this.$refs.handleDialog.openProcess(row.item_id);
    },
    handleProjectReview: function handleProjectReview(row) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this10.selectedId = row.id;
              _this10.selectedProjectType = row.project_type;
              _this10.selectedProjectStatus = _this10.getProjectStatus(row);
              _this10.applyFormType = 'projectReview';
              _this10.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
              _this10.applyFormVisible = true;
            case 1:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getProjectStatus: function getProjectStatus(row) {
      return row.status;
    },
    openFollowUp: function openFollowUp(row) {
      this.followUpProjectId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.followUpTaskId = this.tabActiveName === '1' ? null : row.item_id;
      this.followUpVisible = true;
    },
    handleBiddingProcess: function handleBiddingProcess(row) {
      this.$refs.handleDialog.openBidding(row.item_id);
    },
    handleDemandStatusClick: function handleDemandStatusClick(row, value) {
      if (value.type == 2) {
        this.handleBiddingStatusClick(row, value);
      } else if (value.type == 3) {
        this.handlePrintingStatusClick(row, value);
      }
    },
    handleBiddingStatusClick: function handleBiddingStatusClick(row, value) {
      if (value.type == 2) {
        this.$refs.biddingStatusDialog.open(row.item_id);
      }
    },
    handlePrintingStatusClick: function handlePrintingStatusClick(row, value) {
      if (value.type == 3 && this.tabActiveName == '4') {
        this.$refs.printingStatusDialog.open(row.item_id);
      }
    },
    handleBiddingResultClick: function handleBiddingResultClick(row) {
      this.$refs.biddingResultDialog.open(row.item_id);
    },
    handleBiddingDeliveryClick: function handleBiddingDeliveryClick(row) {
      this.$refs.biddingDeliveryDialog.open(row.item_id);
    },
    handleCardAndCouponDesignProcess: function handleCardAndCouponDesignProcess(row) {
      this.$refs.handleDialog.openCardAndCouponDesign(row.item_id);
    },
    handleProjectProcess: function handleProjectProcess(row) {
      this.$refs.handleDialog.openProject(row.id);
    },
    handleDialogSuccess: function handleDialogSuccess() {
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    changeCreatedTime: function changeCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeUpdatedTime: function changeUpdatedTime(val) {
      this.searchForm.start_updated_at = val ? val[0] : '';
      this.searchForm.end_updated_at = val ? val[1] : '';
    },
    changeProjectCreatedTime: function changeProjectCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeMallCreatedTime: function changeMallCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeBiddingCreatedTime: function changeBiddingCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeQuotationCreatedTime: function changeQuotationCreatedTime(val) {
      this.quotationSearchForm.created_start = val ? val[0] : '';
      this.quotationSearchForm.created_end = val ? val[1] : '';
    },
    // 定制设计及印刷：跟进记录首条高亮，其余历史条目调浅
    getFollowUpItemClass: function getFollowUpItemClass(index) {
      if (this.tabActiveName !== '4') return '';
      return index === 0 ? 'follow-up-first' : 'follow-up-muted';
    },
    exportPrinting: function exportPrinting() {
      var _this11 = this;
      getMyToDoPrintingExcel(_objectSpread({}, this.searchForm)).then(function (res) {
        if (res.data) {
          _this11.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
        }
      });
    },
    handleAddCard: function handleAddCard(row) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var event;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              event = _this12.$refs.addCardDialog;
              event.open(row);
            case 1:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    handleAddCardSuccess: function handleAddCardSuccess() {
      // 按用户要求：只关闭弹框，不刷新
    },
    // 侧滑打开【创建印刷单】—— 参数 schema 后续定义
    openPrintingRecordDrawer: function openPrintingRecordDrawer(params) {
      this.printingRecordDrawer.params = {
        id: params.card_make_print_id === '0' ? '' : params.card_make_print_id,
        batch: params.batch || '',
        type: params.card_make_print_id === '0' ? 'add' : 'edit',
        project_id: params.project_id || '',
        item_id: params.item_id || '',
        from: 'project',
        is_make_card: '0',
        is_getApi: '1'
      };
      this.printingRecordDrawer.visible = true;
    },
    handlePrintingRecordSuccess: function handlePrintingRecordSuccess() {
      this.printingRecordDrawer.visible = false;
      this.getlist();
    }
  }
};